import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import * as routing from '../../../../constants/Routing';
import { useRetrieveActiveProject } from '../../../../hooks/project/useRetrieveActiveProject';

interface NavigateToPlanProps {
  planId: string;
  invalidateQueries?: boolean;
  executionDate?: Date;
}

interface UseManagePlanQueryResponse {
  clearPlanQueries: () => void;
  navigateToPlan: ({ planId, invalidateQueries }: NavigateToPlanProps) => void;
}

export const useManagePlanQuery = (): UseManagePlanQueryResponse => {
  const navigate = useNavigate();
  const { data: activeProject } = useRetrieveActiveProject();
  const queryClient = useQueryClient();

  const clearPlanQueries = () => {
    queryClient.invalidateQueries({ queryKey: [`planner_search_plans_range`] });
    queryClient.invalidateQueries({ queryKey: [`planner_search_plans_day`] });
  };

  const navigateToPlan = (props: NavigateToPlanProps) => {
    if (!activeProject) return;
    const { planId, invalidateQueries } = props;

    if (invalidateQueries) {
      clearPlanQueries();
    }

    navigate(routing.PLANNER.PLAN_DETAILS.OVERVIEW.replace(`:projectId`, activeProject.id).replace(`:planId`, planId));
  };

  return {
    clearPlanQueries,
    navigateToPlan,
  };
};
